import type { EvolutionRecord } from '../../utils/evolutionRecordPolicy';

/** Linha curta para o diálogo de invalidação (data + profissional). */
export function evolutionInvalidateDialogSubtitle(evo?: EvolutionRecord | null): string {
  if (!evo) return '';
  const parts: string[] = [];
  if (evo.evolution_date) {
    parts.push(new Date(`${evo.evolution_date}T12:00:00`).toLocaleDateString('pt-BR'));
  }
  const prof = evo.professional?.full_name;
  if (prof) parts.push(String(prof));
  return parts.join(' — ');
}
